import { render, staticRenderFns } from "./LatestSection.vue?vue&type=template&id=222a262a&scoped=true"
import script from "./LatestSection.vue?vue&type=script&lang=js"
export * from "./LatestSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222a262a",
  null
  
)

export default component.exports